import React from 'react';
import classnames from 'classnames';
import { gikClassPrefix } from '@gik/core/constants';
import NumberFormat, { NumberFormatProps, NumberFormatValues } from 'react-number-format';
import Input, { InputProps, inputBlockName } from './Input';

export interface InputNumberProps extends InputProps {
  formatProps?: NumberFormatProps;

  onFormattedValueChange?(value: NumberFormatValues): void;
}

// block name for this component
const blockName = `${gikClassPrefix}-input-number`;

/**
 * GIK Input component for formatted numbers
 */
function InputNumber({
  className,
  onValueChange,
  onFormattedValueChange,
  formatProps = {},
  ...otherProps
}: InputNumberProps): React.ReactElement {
  const blockClasses = classnames([blockName, className || '']);

  // use thousands separator by default
  if (formatProps.thousandSeparator === undefined) formatProps.thousandSeparator = true;
  // also pass the placeholder to the NumberFormat component
  formatProps.placeholder = otherProps.placeholder;

  function handleValueChange(values: NumberFormatValues): void {
    if (onFormattedValueChange) onFormattedValueChange(values);
    if (onValueChange) onValueChange(values.value);
  }

  delete otherProps.onChange;

  // prettier-ignore
  // prettier will condense this... remove when more props are added
  return (
    <Input
      className={blockClasses}
      customInput={(customProps) =>
        <NumberFormat
          className={`${inputBlockName}__input`}
          onValueChange={handleValueChange}
          onFocus={customProps.onFocus}
          onBlur={customProps.onBlur}
          {...formatProps}
        />
      }
      {...otherProps}
    />
  );
}

export default InputNumber;
